import { Modal, ModalBody, ModalContent, ModalOverlay, useDisclosure, useToast } from "@chakra-ui/react";
import { Box, Text, GridItem, Flex, Button } from "@chakra-ui/react";
import {ReducedProposal } from "@/models/proposal.model";
import { cpfFormatter } from "@/utils/cpfFormatter";
import { format } from "date-fns";
import ProposalModal from "../ProposalModal";
import { BrlCurrencyFormatter } from "@/utils/BrlCurrencyFormatter";
import { getStatusProps, ProposalStatus } from "../ProposalTable/proposalStatusRenderer";
import FixProposalModal from "../FixProposalModal";
import { getNaturalPersonById } from "@/services/naturalPerson.service";
import { createBioValidation } from "@/services/bioValidation.service";
import { useState } from "react";
import BankDetailModal from "../BankDetailModal";
import BankAndPersonalDetailModal from "../BankAndPersonalDetailModal.ts/index.tsx";
import Logo from "../Logo/index.tsx";
import { getProposalStatusAndCustomStatus } from "@/utils/getProposalStatusAndCustomStatus.ts";


interface ProposalCardProps {
  proposal: ReducedProposal;

}

export default function ProposalCard({ proposal }: ProposalCardProps) {

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loadingConfirmation] = useState<boolean>(false);

  const {
    isOpen: isFixOpen,
     onOpen: onFixOpen,
    onClose: onFixClose,
  } = useDisclosure();
  const toast = useToast();

  const formatDate = (date: string): string => {
    const dateObj = new Date(date);
    return isNaN(dateObj.getTime())
      ? "Data não disponível"
      : format(dateObj, "dd/MM/yyyy - HH:mm");
  };
  const [isBankDetailFormOpen, setIsBankDetailFormOpen] = useState(false);
  const [isBankAndPersonalDetailFormOpen, setIsBankAndPersonalDetailFormOpen] = useState(false);
  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onOpen();
  };


 const handleButtonFixClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onFixOpen();
  };

  const handleButtonFormalizationClick = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    onClose();
    try {
      // setLoadingConfirmation(true);

      const naturalPerson = await getNaturalPersonById(proposal.naturalPersonId!);
      const request = {
        proposalId: proposal.id,
        naturalPerson: naturalPerson,
      };

      await createBioValidation(request);
      toast({
        title: `Formalização criada com sucesso`,
        description: "A formalização foi criada com sucesso.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error creating bio validation:", error);

      toast({
        title: `Erro ao criar formalização`,
        description: "Ocorreu um erro ao criar a formalização.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <GridItem>
        <Box
          borderWidth="1px"
          borderRadius="lg"
          overflow="hidden"
          transition="transform 0.3s ease, box-shadow 0.3s ease"
          boxShadow="md"
          position="relative"
          bg="white"
          _hover={{
            transform: "scale(1.05)",
            boxShadow: "lg",
          }}
          cursor="pointer"
          onClick={onOpen}
          display="flex"
          flexDirection="column"
          height="100%"
          width={"100%"}
        >
          <Flex
            bg="secondary"
            height="50px"
            justify="space-between"
            alignItems="center"
            p={4}
            bgColor={getStatusProps(proposal.status!).color}
          >
            <Text
              fontSize="0.94rem"
              fontFamily="Lexend Deca"
              fontWeight="bold"
              color="white"
            >
              {getProposalStatusAndCustomStatus(proposal?.status as ProposalStatus, proposal?.customStatus!)}  
            </Text>
          </Flex>
          <Box
            p={4}
            flex="1"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
          >
            <Flex direction="column" alignItems="flex-start">
              <Flex alignItems="center" gap={1}>
                <Text
                  fontSize="0.94rem"
                  color="gray.700"
                  fontFamily="Lexend Deca"
                >
                  Nome:
                </Text>
                <Text fontSize="0.94rem" fontFamily="Lexend Deca" isTruncated>
                  {proposal?.naturalPersonName || "Não disponível"}
                </Text>
              </Flex>
              <Flex alignItems="center" gap={2}>
                <Text fontSize="0.94rem" color="gray.700">
                  CPF:
                </Text>
                <Text
                  fontSize="0.94rem"
                  color="blue.600"
                  fontFamily="Lexend Deca"
                >
                  {cpfFormatter(proposal?.naturalPersonDocument!)}
                </Text>
              </Flex>
              <Flex alignItems="center" gap={2}>
                <Text fontSize="0.94rem" color="gray.700">
                  Valor Liberado:
                </Text>
                <Text
                  fontSize="0.94rem"
                  color="green.600"
                  fontFamily="Lexend Deca"
                >
                  {BrlCurrencyFormatter(
                    proposal.financialReleasedAmount
                  )}
                </Text>
              </Flex>
              <Flex alignItems="center" gap={2}>
                <Text fontSize="0.94rem" color="gray.700">
                  Vendedor:
                </Text>
                <Text
                  fontSize="0.94rem"
                  color="gray.800"
                  fontFamily="Lexend Deca"
                  isTruncated
                  maxW="150px"
                >
                  {`${proposal?.sellerName} ${proposal.sellerLastName}` ||
                    "Não disponível"}
                </Text>
              </Flex>
            </Flex>

            <Flex flexDirection="row" alignItems="center" gap="3" mt={4}>
              <>
                <Button
                  fontSize="0.94rem"
                  colorScheme="primary"
                  onClick={handleButtonClick}
                  mb={5}
                  fontFamily="Lexend Deca"
                >
                  Ver Proposta
                </Button>
                <Button
                  fontSize="0.94rem"
                  colorScheme="primary"
                  onClick={handleButtonFixClick}
                  mb={5}
                  fontFamily="Lexend Deca"
                >
                  Correções
                </Button>

                <Button
                  fontSize="0.94rem"
                  colorScheme="primary"
                  onClick={handleButtonFormalizationClick}
                  mb={5}
                  fontFamily="Lexend Deca"
                  isDisabled={
                    proposal.status !== "ERROR_CREATE_BIOMETRIC_VALIDATION"
                  }
                >
                  Criar Formalização 
                </Button>
              </>
            </Flex>
            <Text
              fontSize="0.625rem"
              color="gray.500"
              position="absolute"
              bottom="10px"
              right="10px"
              fontWeight="bold"
              fontFamily="Lexend Deca"
            >
              Criado em {formatDate(proposal.naturalPersonUpdatedAt ?? "")}
            </Text>
          </Box>
        </Box>
      </GridItem>
      <BankDetailModal
        isOpen={isBankDetailFormOpen}
        onClose={() => setIsBankDetailFormOpen(false)}
        proposalId={proposal.id}
      />
      <BankAndPersonalDetailModal
        isOpen={isBankAndPersonalDetailFormOpen}
        onClose={() => setIsBankAndPersonalDetailFormOpen(false)}
        proposalId={proposal.id}
      />
      {isOpen && (
        <ProposalModal isOpen={isOpen} onClose={onClose} proposalId={proposal.id} />
      )}
      <FixProposalModal isOpen={isFixOpen} onClose={onFixClose} proposalId={proposal.id} />
           <Modal isOpen={loadingConfirmation} onClose={() => {}} isCentered>
        <ModalOverlay />
        <ModalContent bg="transparent" boxShadow="none">
          <ModalBody display="flex" flexDirection="column" alignItems="center">
            <Logo
              variant="primary"
              w="100px"
              alt="Logo"
              animation={`pulse 2s infinite`}
            />
            <Text mt={4} fontSize="xl" color="white" fontWeight="bold">
              {"Criando formalização..."}
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
